let statuses = [
    { title: 'Cancelled', value: 'cancelled' },
    { title: 'Ready to Dispatch', value: 'readyToDispatch'}
]

export default statuses;
